import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { _ProductDetail } from "./Products";
import { ParsedImage } from "./ProductDetailGallery";
import { renderDifficultyBadge } from "./difficulty";
interface Image {
    id: number;
    file: string;
    type: string;
  }
  


interface GallerySwiperMobileProps {
    pDetailData: _ProductDetail;
}

const GallerySwiperMobile: React.FC<GallerySwiperMobileProps> = ({ pDetailData }) => {
    const urlImgPlaceholder = "/img/img_placeholder.jpg";
    const [valImgFile, setValImgFile] = useState(urlImgPlaceholder);
    const [valUrlImg, setValUrlImg] = useState(pDetailData.thumbnail);
    const [idThumbsImg, setIdThumbsImg] = useState(0);
    const [parsedImgs,setParsedImgs] =useState<ParsedImage[]>();
    const [imgList,setImgList] = useState<{
        id: number;
        file: string;
        type: string;
    }[]>(pDetailData.images);
    
    const parseImages = (data: Image[]): ParsedImage[] => {
        const result: ParsedImage[] = [];
        let current: ParsedImage | null = null;
        for (const item of data) {
            if (item.type === "origin") {
                current = { id: item.id, file: item.file, type: "origin", subtypes: [] };
                result.push(current);
            } else if (current) {
                current.subtypes.push({ id: item.id, file: item.file, type: item.type });
            }
        }
        if (result[0]) {
            const max = result[0].subtypes.find(s => s.type === "max");
            setValUrlImg(max?.file || result[0].file);
            setIdThumbsImg(result[0].id);
        }
        return result;
      };

      useEffect(()=>{
        setParsedImgs(parseImages(pDetailData.images));
    },[])

    const checkDifficulty = () => renderDifficultyBadge(pDetailData.difficulty);
    /*
    const parseImages = (data: Image[]): ParsedImage[] => {
        let result: ParsedImage[] = []
        for(let i=0;i<data.length;i++){
            if(i%4===0){

              let line : ParsedImage = { id:0,
                file: "",
                type: "",
                subtypes:  [
                ]};
                    result.push(line);
                
            }
      
                    if(data[i].type==="main"){
                    result[result.length-1].type=data[i].type;
                    result[result.length-1].file=data[i].file;
                    result[result.length-1].id=data[i].id;
                    }else{
                        result[result.length-1].subtypes.push({
                            type:data[i].type,
                            file:data[i].file,
                            id:data[i].id
                        });
                    }

        } 
        return result;
      };
      
    
    useEffect(()=>{
        setParsedImgs(parseImages(pDetailData.images));
    },[])
*/
    return (
        <div className="swiper mobile">
            {parsedImgs && parsedImgs.length > 0 && (
            <Swiper
                modules={[Navigation, Pagination, A11y]}
                navigation={true}
                spaceBetween={50}
                slidesPerView={1}
                pagination={{ clickable: true }}
                // rewind: na poslední fotce swipe dál pokračuje na první — bez mrtvého konce,
                // kde se gesta zasekávala, dokud se neklikl na šipku
                rewind={true}
                watchOverflow={true}
                observer={true}
                observeParents={true}
                threshold={5}
            >
                {parsedImgs.map((image: ParsedImage) => (
                    <SwiperSlide key={image.id}>
                        <div className="img">
                            <img
                                src={image.file || urlImgPlaceholder}
                                onError={() => setValImgFile(urlImgPlaceholder)}
                                alt={image.type}
                                width="768"
                                height="1024"
                            />
                            {checkDifficulty()}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            )}
        </div>
    );
};

export default GallerySwiperMobile;